export var PAGE_SIZE_OPTIONS = [{
  value: 25,
  label: '25'
}, {
  value: 50,
  label: '50'
}, {
  value: 100,
  label: '100'
}, {
  value: 200,
  label: '200'
}];
export var ELLIPSIS_MARKER = undefined;
export var INITIAL_PAGE = 1;